import { getLocale } from "@/models/utils";
import i18n from "i18next";
import { Device } from "@capacitor/device";
import { AUDIO_LANGUAGES } from "@/constants";
import { isNativeApp } from "@/models/platform";
import { initReactI18next } from "react-i18next";

import ar from "./ar.json";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import ms from "./ms.json";
import fr from "./fr.json";
import hi from "./hi.json";
import id from "./id.json";
import it from "./it.json";
import ja from "./ja.json";
import ko from "./ko.json";
import nl from "./nl.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ru from "./ru.json";
import sv from "./sv.json";
import th from "./th.json";
import tr from "./tr.json";
import uk from "./uk.json";
import zh from "./zh.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  ms: { translation: ms },
  it: { translation: it },
  pt: { translation: pt },
  nl: { translation: nl },
  hi: { translation: hi },
  id: { translation: id },
  ja: { translation: ja },
  ko: { translation: ko },
  pl: { translation: pl },
  ru: { translation: ru },
  sv: { translation: sv },
  th: { translation: th },
  tr: { translation: tr },
  ar: { translation: ar },
  uk: { translation: uk },
  zh: { translation: zh },
};

const appLanguages = Object.keys(resources).map((item) =>
  AUDIO_LANGUAGES.find((lang) => lang.value === item)
);

if (!i18n.isInitialized && typeof window === "object") {
  if (isNativeApp()) {
    Device.getLanguageTag().then((languageCode) => {
      const deviceLang =
        localStorage.getItem("locale") || languageCode.value.slice(0, 2);

      i18n.use(initReactI18next).init({
        resources,
        lng: deviceLang,
        fallbackLng: "en",
        compatibilityJSON: "v4",
        interpolation: {
          escapeValue: false,
        },
      });
    });
  } else {
    let deviceLang = localStorage.getItem("locale") || getLocale();
    const urlLang = window.location.href.includes("?lang=")
      ? window.location.href.split("?lang=")[1]
      : null;
    if (urlLang) {
      deviceLang = urlLang.slice(0, 2);
      localStorage.setItem("locale", deviceLang);
    }

    i18n.use(initReactI18next).init({
      resources,
      lng: deviceLang,
      fallbackLng: "en",
      compatibilityJSON: "v4",
      interpolation: {
        escapeValue: false,
      },
    });
  }
}

export { i18n, appLanguages };
